import { ToastQueue } from '@heroui/react'

// Custom queue that bypasses document.startViewTransition so the page
// doesn't snapshot/cross-fade on every toast, which caused visible blinking.
export const toastQueue = new ToastQueue({
  wrapUpdate: (fn) => fn(),
})

type ToastOptions = {
  description?: string
  timeout?: number
  onClose?: () => void
}

function addToast(message: string, options?: ToastOptions & { variant?: 'default' | 'success' | 'danger' | 'warning' | 'accent' }) {
  const timeout = options?.timeout !== undefined ? options.timeout : 4000
  return toastQueue.add(
    { title: message, description: options?.description, variant: options?.variant || 'default' },
    { timeout, onClose: options?.onClose },
  )
}

addToast.success = (message: string, options?: ToastOptions) => addToast(message, { ...options, variant: 'success' })
addToast.danger  = (message: string, options?: ToastOptions) => addToast(message, { ...options, variant: 'danger' })
addToast.warning = (message: string, options?: ToastOptions) => addToast(message, { ...options, variant: 'warning' })
addToast.info    = (message: string, options?: ToastOptions) => addToast(message, { ...options, variant: 'accent' })

export const toast = addToast
